"use strict";
// -----------------------------------------------------------------------------
// Konstanten für Report-Konfiguration
// siehe auch reportConfig.<env>.json Dateien
// -----------------------------------------------------------------------------
Object.defineProperty(exports, "__esModule", { value: true });
exports.FLAECHEN_TABLE_ID = exports.FLAECHEN_EXPORT_BUTTON_ID = exports.MILCHANLIEFERUNG_TABLE_ID = exports.MILCHANLIEFERUNG_EXPORT_BUTTON_ID = exports.BOERSEPREISE_TABLE_DATE_COLUMN_NAME = exports.BOERSEPREISE_TABLE_NAME = exports.BOERSEPREISE_TABLE_ID = exports.BOERSEPREISE_YEAR_SLICER_COLUMN_NAME = exports.BOERSEPREISE_YEAR_SLICER_TABLE_NAME = exports.BOERSEPREISE_YEAR_SLICER_ID = exports.BOERSEPREISE_EXPORT_BUTTON_ID = exports.MARKTDATEN_TABLE_DATE_COLUMN_NAME = exports.MARKTDATEN_TABLE_NAME = exports.MARKTDATEN_TABLE_ID = exports.MARKTDATEN_YEAR_SLICER_COLUMN_NAME = exports.MARKTDATEN_YEAR_SLICER_TABLE_NAME = exports.MARKTDATEN_YEAR_SLICER_ID = exports.MARKTDATEN_RESET_BUTTON_ID = exports.MARKTDATEN_EXPORT_BUTTON_ID = exports.MARKTDATEN_BARCHART_BUTTON_ID = exports.MARKTDATEN_LINECHART_BUTTON_ID = exports.MARKTDATEN_TABLE_BUTTON_ID = exports.MARKTDATEN_PREISBERICHT_BOOKMARK = exports.MARKTDATEN_PREISBERICHT_YEAR_COUNT = exports.MARKTDATEN_DEFAULT_YEAR_COUNT = exports.RC_FLAECHENAUSWERTUNG = exports.RC_MILCHANLIEFERUNG = exports.RC_BOERSENPREISE = exports.RC_MARKDATEN = exports.RC_VORSCHAU_VIEH = exports.RC_VORSCHAU_MILCH = exports.RC_VORSCHAU_EIER = exports.RC_VORSCHAU_GETREIDE = exports.RC_VORSCHAU_OBST = void 0;
// Konstanten für Report-Codes Startseite (Vorschau)
exports.RC_VORSCHAU_OBST = "VorschauObst";
exports.RC_VORSCHAU_GETREIDE = "VorschauGetreide";
exports.RC_VORSCHAU_EIER = "VorschauEier";
exports.RC_VORSCHAU_MILCH = "VorschauMilch";
exports.RC_VORSCHAU_VIEH = "VorschauVieh";
// Konstanten für Report-Codes
exports.RC_MARKDATEN = "Markdaten";
exports.RC_BOERSENPREISE = "Boersenpreise";
exports.RC_MILCHANLIEFERUNG = "Milchanlieferung";
exports.RC_FLAECHENAUSWERTUNG = "Flaechenauswertung";
// -----------------------------------------------------------------------------
// Report Marktdaten
// -----------------------------------------------------------------------------
exports.MARKTDATEN_DEFAULT_YEAR_COUNT = 3;
exports.MARKTDATEN_PREISBERICHT_YEAR_COUNT = 2;
// Konstanten für Bookmarks in Markdaten Report
exports.MARKTDATEN_PREISBERICHT_BOOKMARK = "79c93ad04b48150455e4";
// Konstanten für Buttons in Marktdaten Report
exports.MARKTDATEN_TABLE_BUTTON_ID = "8775b7f6344ee1e4e02b";
exports.MARKTDATEN_LINECHART_BUTTON_ID = "1f1840712eb832aab27c";
exports.MARKTDATEN_BARCHART_BUTTON_ID = "0a669c1007d5d8b562a5";
exports.MARKTDATEN_EXPORT_BUTTON_ID = "c947e81864007e7ecd43";
exports.MARKTDATEN_RESET_BUTTON_ID = "ffc84e3ede543f42a86c";
// Konstanten für Visuals in Marktdaten Report
exports.MARKTDATEN_YEAR_SLICER_ID = "4ecdad6eaa7893ed2448";
exports.MARKTDATEN_YEAR_SLICER_TABLE_NAME = "MELDUNGSDATEN";
exports.MARKTDATEN_YEAR_SLICER_COLUMN_NAME = "Jahr";
exports.MARKTDATEN_TABLE_ID = "64dcaf04cb8978e950ed";
exports.MARKTDATEN_TABLE_NAME = "MELDUNGSDATEN";
exports.MARKTDATEN_TABLE_DATE_COLUMN_NAME = "DATUM_TABELLE";
// -----------------------------------------------------------------------------
// Report Böresepreise
// -----------------------------------------------------------------------------
// Konstanten für Buttons in Böresepreise Report
exports.BOERSEPREISE_EXPORT_BUTTON_ID = "c947e81864007e7ecd43";
// Konstanten für Visuals in Böresepreise Report
exports.BOERSEPREISE_YEAR_SLICER_ID = "4ecdad6eaa7893ed2448";
exports.BOERSEPREISE_YEAR_SLICER_TABLE_NAME = "MELDUNGSDATEN";
exports.BOERSEPREISE_YEAR_SLICER_COLUMN_NAME = "Jahr";
exports.BOERSEPREISE_TABLE_ID = "64dcaf04cb8978e950ed";
exports.BOERSEPREISE_TABLE_NAME = "MELDUNGSDATEN";
exports.BOERSEPREISE_TABLE_DATE_COLUMN_NAME = "DATUM_TABELLE";
// -----------------------------------------------------------------------------
// Report Milchanlieferung
// -----------------------------------------------------------------------------
// Konstanten für Buttons in Milchanlieferung Report
exports.MILCHANLIEFERUNG_EXPORT_BUTTON_ID = "ac79bee92fc3fbec219d";
// Konstanten für Visuals in Milchanlieferung Report
exports.MILCHANLIEFERUNG_TABLE_ID = "1656c37632aaea0daca7";
// -----------------------------------------------------------------------------
// Report Flächenauswertung
// -----------------------------------------------------------------------------
// Konstanten für Buttons in Flächenauswertung Report
exports.FLAECHEN_EXPORT_BUTTON_ID = "1120f9716acbff6a66a3";
// Konstanten für Visuals in Flächenauswertung Report
exports.FLAECHEN_TABLE_ID = "44f58d5f244ec33ed69d";
